/**用户管理 */
export default {
    name: 'usermanage',
    path: 'usermanage',
    meta: { title: '用户管理' },
    component: () => import('@/pages/index.vue'),
    children: [
        {
            name: 'usermanage-userlist',
            path: 'userlist',
            meta: { title: '用户列表' },
            component: () => import('@/pages/usermanage/userlist.vue')
        }
    ]
}